import {Layer} from '../Layer.js';
import {Animate} from '../Animate.js';
import {MetarLayer} from '../layers/Metar.js';
import {TafLayer} from '../layers/Taf.js';
import Library from '../Library.js';

export class MetarTafLayer extends Layer {
    metar = undefined;
    taf = undefined;

    constructor( map, settings = {} ){
        if( settings.name == undefined ) settings['name'] = "metartaf";;
        settings["dynamic_time"] = true;
        super( map, settings );
        
        let msettings = { ...settings };
        msettings['visible'] = this.map.secs > this.map.init_secs? false: this.settings['visible'];
        console.info( 'metar', msettings );
        this.metar = new MetarLayer( map, msettings );
        this.map.addLayer( this.metar );

        let tsettings = { ...settings };
        tsettings['visible'] = this.map.secs > this.map.init_secs? this.settings['visible']: false;
        console.info( 'taf', tsettings );
        this.taf = new TafLayer( map, tsettings );
        this.map.addLayer( this.taf );
    }

    set( key, val ){

        if( key == "visible" )
            this.setVisible( val );
        else {
            this.metar.set( key, val );
            this.taf.set( key, val );
        }
    }

    setVisible( val ){
        if( this.map.secs > this.map.init_secs ){
            this.metar.setVisible( false );
            this.taf.setVisible( this.settings['visible'] );
        } else {
            this.metar.setVisible( this.settings['visible'] );
            this.taf.setVisible( false );
        }
        this.settings['visible'] = val;
        return this.settings['visible'];
    }

    updateTime(){
        this.setVisible( this.settings['visible'] );
        this.refresh();
    }
}
